import { apiClient } from './client';
import type { ApiSuccess } from '../types';
import type { BulkResult } from './bulkOnboard.api';

type Row = Record<string, unknown>;

export const amBulkApi = {
  async stations(rows: Row[]): Promise<BulkResult> {
    return (await apiClient.post<ApiSuccess<BulkResult>>('/am-bulk/stations', { rows })).data.data;
  },
  async rent(rows: Row[]): Promise<BulkResult> {
    return (await apiClient.post<ApiSuccess<BulkResult>>('/am-bulk/rent', { rows })).data.data;
  },
  async electricity(rows: Row[]): Promise<BulkResult> {
    return (await apiClient.post<ApiSuccess<BulkResult>>('/am-bulk/electricity', { rows })).data.data;
  },
};
